import React, { useState } from "react";
import {
  Box,
  Typography,
  Card,
  CardContent,
  Avatar,
  styled,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import { formattedAmountWithoutAed } from "../../../utils/CommonFunction";
import { statusStyleArray } from "../config";
import { ReactComponent as MwebDhiramIcon } from "../../../assets/svg/MwebDhiramIcon.svg";

const StyledCard = styled(Card)(({ theme }) => ({
  margin: "0 !important",
  borderRadius: "0",
  boxShadow: "none",
  borderBottom: "1px solid #D7D8D9",
}));

export const getStatusDisplayText = (text) => {
  if (typeof text !== "string") return text;
  const displayText = text
    .replace(/[-_]/g, " ")
    .toLowerCase()
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
  return displayText;
};

export default function MobileProjectCards({ details, loading }) {
  const navigate = useNavigate();
  const [selectedProjects, setSelectedProjects] = useState([]);

  const handleProjectClick = (item) => {
    navigate(`/project/details/${item?.proposal_id}`);
  };

  const handleProjectSelect = (projectId) => {
    setSelectedProjects((prev) =>
      prev.includes(projectId)
        ? prev.filter((id) => id !== projectId)
        : [...prev, projectId]
    );
  };

  if (loading) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: 200,
        }}
      >
        <Typography variant="body1" sx={{ color: "#6B7280" }}>
          Loading...
        </Typography>
      </Box>
    );
  }

  if (!details || details.length === 0) {
    return (
      <Typography
        variant="body1"
        sx={{ textAlign: "center", marginTop: 4, color: "#6B7280" }}
      >
        No projects available
      </Typography>
    );
  }

  return (
    <Box sx={{ padding: "0 2vw" }}>
      {details.map((item) => (
        <StyledCard key={item.id} onClick={() => handleProjectClick(item)}>
          <CardContent sx={{ padding: "16px" }}>
            <Box
              sx={{
                flex: 1,
                display: "flex",
                flexDirection: "column",
                gap: "8px",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "flex-start",
                }}
              >
                <Box
                  sx={{
                    flex: 1,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <Typography
                    sx={{
                      fontSize: "16px",
                      fontWeight: "600",
                      color: "#0D0D0E",
                      maxWidth: "60%",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                    }}
                  >
                    {item?.name}
                  </Typography>

                  <Typography
                    sx={{
                      fontSize: "14px",
                      color: "#6B7280",
                      marginRight: "8px",
                    }}
                  >
                    {item?.project_type}
                  </Typography>
                </Box>
              </Box>

              <Box
                sx={{
                  display: "flex",
                  gap: "16px",
                  marginBottom: "12px",
                }}
              >
                <Box sx={{ display: "flex", alignItems: "center" }}>
                  <Avatar
                    sx={{
                      width: "32px",
                      height: "32px",
                      fontSize: "12px",
                      marginRight: "6px",
                    }}
                    src={item?.user_data?.profile_url}
                  >
                    {item?.user_data?.username?.charAt(0)?.toUpperCase() ||
                      item?.username?.charAt(0)?.toUpperCase() ||
                      "U"}
                  </Avatar>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "0px",
                    }}
                  >
                    <Typography sx={{ fontSize: "12px", color: "#949DAA" }}>
                      Customer
                    </Typography>
                    <Typography
                      sx={{
                        fontSize: "13px",
                        fontWeight: "500",
                        color: "#0D0D0E",
                      }}
                    >
                      {item?.user_data?.username || item?.username}
                    </Typography>
                  </Box>
                </Box>
              </Box>

              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "2px",
                }}
              >
                <Typography
                  sx={{
                    fontSize: "12px",
                    color: "#949DAA",
                    fontWeight: 500,
                  }}
                >
                  Start/ End Date
                </Typography>
                <Typography
                  sx={{
                    fontSize: "12px",
                    fontWeight: "500",
                    color: "#0D0D0E",
                  }}
                >
                  {item?.start_date && item?.end_date
                    ? `${moment(item.start_date).format("DD MMM")} - ${moment(
                        item.end_date
                      ).format("DD MMM, YYYY")}`
                    : item?.start_date
                    ? moment(item.start_date).format("DD MMM, YYYY")
                    : item?.end_date
                    ? moment(item.end_date).format("DD MMM, YYYY")
                    : "-"}
                </Typography>
              </Box>

              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  margin: ".5vh 0",
                }}
              >
                <Box>
                  <Typography
                    sx={{ fontSize: "12px", color: "#949DAA", fontWeight: 500 }}
                  >
                    Cost
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: "14px",
                      fontWeight: "600",
                      color: "#0D0D0E",
                      marginBottom: "4px",
                      display: "flex",
                      alignItems: "center",
                      gap: "6px",
                    }}
                  >
                    <MwebDhiramIcon /> {formattedAmountWithoutAed(item?.cost)}
                  </Typography>
                </Box>

                {/* <Box>
                  <Typography
                    sx={{ fontSize: "12px", color: "#949DAA", fontWeight: 500 }}
                  >
                    Payment Terms
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: "12px",
                      color: "#4D6BF6",
                      fontWeight: "500",
                      marginTop: "4px",
                    }}
                  >
                    Open
                  </Typography>
                </Box> */}
              </Box>

              <Box sx={{ display: "flex", alignItems: "center" }}>
                <Box
                  sx={{
                    width: "15px",
                    height: "15px",
                    borderRadius: "50%",
                    backgroundColor:
                      statusStyleArray.find(
                        (style) => style.status === item?.status
                      )?.backgroundColor || "#E5E5E5",
                    marginRight: "6px",
                    border: "3px solid #e5e5e5",
                  }}
                />
                <Typography
                  sx={{
                    fontSize: "12px",
                    fontWeight: "500",
                    color: "#0D0D0E",
                  }}
                >
                  {getStatusDisplayText(item?.status)}
                </Typography>
              </Box>
            </Box>
          </CardContent>
        </StyledCard>
      ))}
    </Box>
  );
}
